import { TFunction } from "react-i18next";
import * as yup from "yup";

export const validateForm = (
  translate: TFunction<"translate", undefined>,
  schemaObject: { email: string, password: string },
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const { email, password } = schemaObject;
    const schema = yup.object().shape({
      email: yup.string().required(translate("emailOrUsernameIsRequired")),
      password: yup.string().required(translate("passwordIsRequired")),
    });

    schema.validateSync(
      {
        email,
        password,
      },
      { abortEarly: false }
    );

    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err.inner);
    }

    return false;
  }
};
